"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _businessHoursUtils = require("./businessHoursUtils");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BusinessHoursPicker',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      WEEK_OPTIONS: _businessHoursUtils.WEEK_OPTIONS,
      MAX_BLOCKS: _businessHoursUtils.MAX_BLOCKS,
      MAX_TIME_SLOTS: _businessHoursUtils.MAX_TIME_SLOTS,
      MAX_INFO_REMARK_LENGTH: _businessHoursUtils.MAX_INFO_REMARK_LENGTH,
      innerList: (0, _businessHoursUtils.createEmptyList)(),
      timePickerOptions: {
        selectableRange: '00:00:00 - 23:59:59'
      },
      syncing: false
    };
  },
  computed: {
    canAddBlock: function canAddBlock() {
      return this.innerList.length < _businessHoursUtils.MAX_BLOCKS;
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        var _this = this;
        this.syncing = true;
        if (Array.isArray(val) && val.length) {
          this.innerList = val.map(function (item) {
            return (0, _businessHoursUtils.normalizeBlock)(item);
          });
        } else {
          this.innerList = (0, _businessHoursUtils.createEmptyList)();
        }
        this.$nextTick(function () {
          _this.syncing = false;
        });
      }
    }
  },
  methods: {
    isWeekStartDisabled: function isWeekStartDisabled(blockIndex, dayValue) {
      return (0, _businessHoursUtils.isWeekStartOptionDisabled)(dayValue, this.innerList, blockIndex);
    },
    isWeekEndDisabled: function isWeekEndDisabled(blockIndex, weekStart, dayValue) {
      return (0, _businessHoursUtils.isWeekEndOptionDisabled)(dayValue, weekStart, this.innerList, blockIndex);
    },
    handleWeekStartChange: function handleWeekStartChange(block, blockIndex) {
      var weekEndStillValid = block.weekEnd >= block.weekStart && !this.isWeekEndDisabled(blockIndex, block.weekStart, block.weekEnd);
      if (!weekEndStillValid) {
        var validWeekEnd = (0, _businessHoursUtils.findFirstValidWeekEnd)(block.weekStart, this.innerList, blockIndex);
        if (validWeekEnd !== null) {
          block.weekEnd = validWeekEnd;
        } else {
          block.weekEnd = block.weekStart;
        }
      }
      this.emitChange();
    },
    handleWeekEndChange: function handleWeekEndChange(block, blockIndex) {
      if (this.isWeekEndDisabled(blockIndex, block.weekStart, block.weekEnd)) {
        var validWeekEnd = (0, _businessHoursUtils.findFirstValidWeekEnd)(block.weekStart, this.innerList, blockIndex);
        block.weekEnd = validWeekEnd !== null ? validWeekEnd : block.weekStart;
      }
      this.emitChange();
    },
    handleTimeChange: function handleTimeChange(block, slotIndex) {
      var slot = block.timeSlots[slotIndex];
      if (!slot || !slot.timeRange || slot.timeRange.length !== 2) {
        this.emitChange();
        return;
      }
      var _slot$timeRange = _slicedToArray(slot.timeRange, 2),
        start = _slot$timeRange[0],
        end = _slot$timeRange[1];
      if (start === end) {
        this.$message.warning('营业开始时间和结束时间不能相同');
        slot.timeRange = null;
        this.emitChange();
        return;
      }
      var duplicated = block.timeSlots.some(function (item, index) {
        if (index === slotIndex) return false;
        return (0, _businessHoursUtils.isTimeRangeOverlap)(slot.timeRange, item.timeRange);
      });
      if (duplicated) {
        this.$message.warning('同一星期范围内的营业时间段不能重复或重叠');
        slot.timeRange = null;
      }
      this.emitChange();
    },
    addTimeSlot: function addTimeSlot(blockIndex) {
      var block = this.innerList[blockIndex];
      if (block.timeSlots.length >= _businessHoursUtils.MAX_TIME_SLOTS) {
        this.$message.warning("\u6700\u591A\u53EF\u914D\u7F6E".concat(_businessHoursUtils.MAX_TIME_SLOTS, "\u4E2A\u8425\u4E1A\u65F6\u95F4\u6BB5"));
        return;
      }
      block.timeSlots.push({
        timeRange: null
      });
      this.emitChange();
    },
    removeTimeSlot: function removeTimeSlot(blockIndex, slotIndex) {
      this.innerList[blockIndex].timeSlots.splice(slotIndex, 1);
      this.emitChange();
    },
    addBlock: function addBlock() {
      if (this.innerList.length >= _businessHoursUtils.MAX_BLOCKS) {
        this.$message.warning("\u6700\u591A\u53EF\u65B0\u589E".concat(_businessHoursUtils.MAX_BLOCKS, "\u4E2A\u8425\u4E1A\u65F6\u95F4"));
        return;
      }
      var newBlock = (0, _businessHoursUtils.createEmptyBlock)();
      var nextIndex = this.innerList.length;
      for (var day = 1; day <= 7; day++) {
        if ((0, _businessHoursUtils.isWeekStartOptionDisabled)(day, this.innerList, nextIndex)) continue;
        newBlock.weekStart = day;
        var weekEnd = (0, _businessHoursUtils.findFirstValidWeekEnd)(day, this.innerList, nextIndex);
        if (weekEnd) {
          newBlock.weekEnd = weekEnd;
          break;
        }
      }
      this.innerList.push(newBlock);
      this.emitChange();
    },
    removeBlock: function removeBlock(blockIndex) {
      this.innerList.splice(blockIndex, 1);
      this.emitChange();
    },
    getWeekRangeText: function getWeekRangeText(weekStart, weekEnd) {
      if (!weekStart || !weekEnd) return '';
      if (weekStart === weekEnd) {
        return _businessHoursUtils.WEEK_LABEL_MAP[weekStart];
      }
      return "".concat(_businessHoursUtils.WEEK_LABEL_MAP[weekStart], "\u81F3").concat(_businessHoursUtils.WEEK_LABEL_MAP[weekEnd]);
    },
    getBlockPreview: function getBlockPreview(block) {
      if (!block.weekStart || !block.weekEnd || block.weekEnd < block.weekStart) {
        return '—';
      }
      var weekText = this.getWeekRangeText(block.weekStart, block.weekEnd);
      var timeTexts = (block.timeSlots || []).filter(function (slot) {
        return slot.timeRange && slot.timeRange.length === 2 && slot.timeRange[0] && slot.timeRange[1];
      }).map(function (slot) {
        return "".concat(slot.timeRange[0], "-").concat(slot.timeRange[1]);
      });
      if (!weekText || !timeTexts.length) {
        return '—';
      }
      var infoRemark = (block.infoRemark || '').trim();
      return "".concat(weekText, " ").concat(timeTexts.join('，')).concat(infoRemark ? " \uFF08".concat(infoRemark, "\uFF09") : '');
    },
    emitChange: function emitChange() {
      if (this.syncing) return;
      var payload = this.innerList.map(function (block) {
        return {
          weekStart: block.weekStart,
          weekEnd: block.weekEnd,
          infoRemark: block.infoRemark || '',
          timeSlots: block.timeSlots.map(function (slot) {
            return {
              timeRange: slot.timeRange ? _toConsumableArray(slot.timeRange) : null,
              beginTime: slot.timeRange ? slot.timeRange[0] : '',
              endTime: slot.timeRange ? slot.timeRange[1] : ''
            };
          })
        };
      });
      this.$emit('input', payload);
      this.$emit('change', payload);
    },
    validate: function validate() {
      var hasAnyConfig = this.innerList.some(function (block) {
        var hasTime = (block.timeSlots || []).some(function (slot) {
          return slot.timeRange && slot.timeRange.length === 2 && slot.timeRange[0] && slot.timeRange[1];
        });
        var hasCustomWeek = block.weekStart && block.weekEnd && (block.weekEnd > block.weekStart || block.weekStart !== 1 || block.weekEnd !== 1);
        return hasTime || hasCustomWeek;
      });
      if (!hasAnyConfig) {
        this.$message.warning('请完善营业时间');
        return false;
      }
      for (var i = 0; i < this.innerList.length; i++) {
        var block = this.innerList[i];
        if (!block.weekStart || !block.weekEnd) {
          this.$message.warning("\u8BF7\u5B8C\u5584\u8425\u4E1A\u65F6\u95F4".concat(i + 1, "\u7684\u661F\u671F\u8303\u56F4"));
          return false;
        }
        if (block.weekEnd < block.weekStart) {
          this.$message.warning("\u8425\u4E1A\u65F6\u95F4".concat(i + 1, "\u7684\u7ED3\u675F\u661F\u671F\u4E0D\u80FD\u65E9\u4E8E\u5F00\u59CB\u661F\u671F"));
          return false;
        }
        for (var j = i + 1; j < this.innerList.length; j++) {
          var other = this.innerList[j];
          if ((0, _businessHoursUtils.isWeekRangeOverlap)(block, other)) {
            this.$message.warning('不同营业时间的星期范围不能重复');
            return false;
          }
        }
        var validSlots = block.timeSlots.filter(function (slot) {
          return slot.timeRange && slot.timeRange.length === 2 && slot.timeRange[0] && slot.timeRange[1];
        });
        if (!validSlots.length) {
          this.$message.warning("\u8BF7\u5B8C\u5584\u8425\u4E1A\u65F6\u95F4".concat(i + 1, "\u7684\u8425\u4E1A\u65F6\u95F4\u6BB5"));
          return false;
        }
        for (var m = 0; m < validSlots.length; m++) {
          for (var n = m + 1; n < validSlots.length; n++) {
            if ((0, _businessHoursUtils.isTimeRangeOverlap)(validSlots[m].timeRange, validSlots[n].timeRange)) {
              this.$message.warning("\u8425\u4E1A\u65F6\u95F4".concat(i + 1, "\u7684\u8425\u4E1A\u65F6\u95F4\u6BB5\u4E0D\u80FD\u91CD\u590D\u6216\u91CD\u53E0"));
              return false;
            }
          }
        }
        var remark = (block.infoRemark || '').trim();
        if (remark.length > _businessHoursUtils.MAX_INFO_REMARK_LENGTH) {
          this.$message.warning("\u8425\u4E1A\u65F6\u95F4".concat(i + 1, "\u7684\u4FE1\u606F\u5907\u6CE8\u4E0D\u80FD\u8D85\u8FC7").concat(_businessHoursUtils.MAX_INFO_REMARK_LENGTH, "\u4E2A\u5B57\u7B26"));
          return false;
        }
      }
      return true;
    }
  }
};